/**
 * CustomerUserUsageType
 */
export enum CustomerUserUsageType {
    FEEDBACK_FORM_EDITORS = 'feedback-form-editors',
    KNOWLEDGEBASE_PAGE_EDITORS = 'knowledgebase-page-editors'
}
